var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInmueblesBalken(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 20.09",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#9f9f9d;stroke-width:0px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_1-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M22.96,18h-.52v-9.91c0-1.01-.82-1.83-1.83-1.83h-6V1.83c0-1.01-.82-1.83-1.83-1.83H3.39c-1.01,0-1.83.82-1.83,1.83v16.17h-.52c-.58,0-1.04.47-1.04,1.04s.47,1.04,1.04,1.04h21.91c.58,0,1.04-.47,1.04-1.04s-.47-1.04-1.04-1.04ZM20.35,8.35v9.65h-5.74v-9.65h5.74ZM3.65,2.09h8.87v15.91H3.65V2.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M6.13,6h2.74c.58,0,1.04-.47,1.04-1.04s-.47-1.04-1.04-1.04h-2.74c-.58,0-1.04.47-1.04,1.04s.47,1.04,1.04,1.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M10.04,10.17h-2.74c-.58,0-1.04.47-1.04,1.04s.47,1.04,1.04,1.04h2.74c.58,0,1.04-.47,1.04-1.04s-.47-1.04-1.04-1.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M8.87,14.09h-2.74c-.58,0-1.04.47-1.04,1.04s.47,1.04,1.04,1.04h2.74c.58,0,1.04-.47,1.04-1.04s-.47-1.04-1.04-1.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M17.09,16.17h.78c.58,0,1.04-.47,1.04-1.04s-.47-1.04-1.04-1.04h-.78c-.58,0-1.04.47-1.04,1.04s.47,1.04,1.04,1.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M17.09,12.26h.78c.58,0,1.04-.47,1.04-1.04s-.47-1.04-1.04-1.04h-.78c-.58,0-1.04.47-1.04,1.04s.47,1.04,1.04,1.04Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInmueblesBalken);
export default __webpack_public_path__ + "static/media/inmuebles_BALKEN.da965cfc6703976d6bd2903e77f79d2a.svg";
export { ForwardRef as ReactComponent };